<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoheadpath'>
    <h2>
      {{token.user}}
      <hr>
    </h2>
    <img class="img-thumbnail img rounded" :src="token.headpath" alt="">
  </div>
  <!-- 导航结束 -->
</template>

<script>
export default {
  name: 'commonClientinfoheadpath',
  props: ['token'],
  data() {
    return {
      isLoading: 1,
    };
  },
  computed: {
  },
  methods: {
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoheadpath{
  background: #FFFFFF;
  width: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0 5px 1rem rgba(0, 0, 0, 0.15);
  position: relative;
  #guanxitupuCanva{
    width: 100%;
    height: 90%;
  }
  .img{
    max-width: 80%;
    max-height: 70%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/headpath.vue